// extracted by mini-css-extract-plugin
export default {"m":"cc8666a300","title":"_3c5aa43245","feedback_inner_title":"_780f16c1ec","textarea":"cd86c15e34","radio":"ef74409449","text":"_9f8f0adbf5"};